export const getLastUrlSegment = (link?: string | null): string | undefined | null =>
  link && link.split('/').pop();
